import { withRouter } from 'react-router';
import UnsubscriptionPage from './unsubscription';

export default withRouter(UnsubscriptionPage);
